export const countryCodes = [
  {
    "country": "AX",
    "name": "Aland Islands",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "AL",
    "name": "Albania",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "AD",
    "name": "Andorra",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "AT",
    "name": "Austria",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "BE",
    "name": "Belgium",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "BA",
    "name": "Bosnia and Herzegovina",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "BG",
    "name": "Bulgaria",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "IC",
    "name": "Canary Islands",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "HR",
    "name": "Croatia",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "CY",
    "name": "Cyprus",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "CZ",
    "name": "Czech Republic",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "DK",
    "name": "Denmark",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "EE",
    "name": "Estonia",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "FO",
    "name": "Faroe Islands",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "FI",
    "name": "Finland",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "FR",
    "name": "France",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "DE",
    "name": "Germany",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "GI",
    "name": "Gibraltar",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "GR",
    "name": "Greece",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "GG",
    "name": "Guernsey",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "VA",
    "name": "Holy See (Vatican City State)",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "HU",
    "name": "Hungary",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "IS",
    "name": "Iceland",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "IE",
    "name": "Ireland",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "IM",
    "name": "Isle of Man",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "IT",
    "name": "Italy",
    "eu": true,
    "language": "en",
    "states": [
      {
        "state": "AG",
        "name": "Agrigento"
      },
      {
        "state": "AL",
        "name": "Alessandria"
      },
      {
        "state": "AN",
        "name": "Ancona"
      },
      {
        "state": "AO",
        "name": "Aosta"
      },
      {
        "state": "AR",
        "name": "Arezzo"
      },
      {
        "state": "AP",
        "name": "Ascoli Piceno"
      },
      {
        "state": "AT",
        "name": "Asti"
      },
      {
        "state": "AV",
        "name": "Avellino"
      },
      {
        "state": "BA",
        "name": "Bari"
      },
      {
        "state": "BT",
        "name": "Barletta-Andria-Trani"
      },
      {
        "state": "BL",
        "name": "Belluno"
      },
      {
        "state": "BN",
        "name": "Benevento"
      },
      {
        "state": "BG",
        "name": "Bergamo"
      },
      {
        "state": "BI",
        "name": "Biella"
      },
      {
        "state": "BO",
        "name": "Bologna"
      },
      {
        "state": "BZ",
        "name": "Bolzano"
      },
      {
        "state": "BS",
        "name": "Brescia"
      },
      {
        "state": "BR",
        "name": "Brindisi"
      },
      {
        "state": "CA",
        "name": "Cagliari"
      },
      {
        "state": "CL",
        "name": "Caltanissetta"
      },
      {
        "state": "CB",
        "name": "Campobasso"
      },
      {
        "state": "CI",
        "name": "Carbonia-Iglesias"
      },
      {
        "state": "CE",
        "name": "Caserta"
      },
      {
        "state": "CT",
        "name": "Catania"
      },
      {
        "state": "CZ",
        "name": "Catanzaro"
      },
      {
        "state": "CH",
        "name": "Chieti"
      },
      {
        "state": "CO",
        "name": "Como"
      },
      {
        "state": "CS",
        "name": "Cosenza"
      },
      {
        "state": "CR",
        "name": "Cremona"
      },
      {
        "state": "KR",
        "name": "Crotone"
      },
      {
        "state": "CN",
        "name": "Cuneo"
      },
      {
        "state": "EN",
        "name": "Enna"
      },
      {
        "state": "FM",
        "name": "Fermo"
      },
      {
        "state": "FE",
        "name": "Ferrara"
      },
      {
        "state": "FI",
        "name": "Firenze"
      },
      {
        "state": "FG",
        "name": "Foggia"
      },
      {
        "state": "FC",
        "name": "Forlì-Cesena"
      },
      {
        "state": "FR",
        "name": "Frosinone"
      },
      {
        "state": "GE",
        "name": "Genova"
      },
      {
        "state": "GO",
        "name": "Gorizia"
      },
      {
        "state": "GR",
        "name": "Grosseto"
      },
      {
        "state": "IM",
        "name": "Imperia"
      },
      {
        "state": "IS",
        "name": "Isernia"
      },
      {
        "state": "AQ",
        "name": "L'Aquila"
      },
      {
        "state": "SP",
        "name": "La Spezia"
      },
      {
        "state": "LT",
        "name": "Latina"
      },
      {
        "state": "LE",
        "name": "Lecce"
      },
      {
        "state": "LC",
        "name": "Lecco"
      },
      {
        "state": "LI",
        "name": "Livorno"
      },
      {
        "state": "LO",
        "name": "Lodi"
      },
      {
        "state": "LU",
        "name": "Lucca"
      },
      {
        "state": "MC",
        "name": "Macerata"
      },
      {
        "state": "MN",
        "name": "Mantova"
      },
      {
        "state": "MS",
        "name": "Massa-Carrara"
      },
      {
        "state": "MT",
        "name": "Matera"
      },
      {
        "state": "VS",
        "name": "Medio Campidano"
      },
      {
        "state": "ME",
        "name": "Messina"
      },
      {
        "state": "MI",
        "name": "Milano"
      },
      {
        "state": "MO",
        "name": "Modena"
      },
      {
        "state": "MB",
        "name": "Monza e della Brianza"
      },
      {
        "state": "NA",
        "name": "Napoli"
      },
      {
        "state": "NO",
        "name": "Novara"
      },
      {
        "state": "NU",
        "name": "Nuoro"
      },
      {
        "state": "OG",
        "name": "Ogliastra"
      },
      {
        "state": "OT",
        "name": "Olbia-Tempio"
      },
      {
        "state": "OR",
        "name": "Oristano"
      },
      {
        "state": "PD",
        "name": "Padova"
      },
      {
        "state": "PA",
        "name": "Palermo"
      },
      {
        "state": "PR",
        "name": "Parma"
      },
      {
        "state": "PV",
        "name": "Pavia"
      },
      {
        "state": "PG",
        "name": "Perugia"
      },
      {
        "state": "PU",
        "name": "Pesaro e Urbino"
      },
      {
        "state": "PE",
        "name": "Pescara"
      },
      {
        "state": "PC",
        "name": "Piacenza"
      },
      {
        "state": "PI",
        "name": "Pisa"
      },
      {
        "state": "PT",
        "name": "Pistoia"
      },
      {
        "state": "PN",
        "name": "Pordenone"
      },
      {
        "state": "PZ",
        "name": "Potenza"
      },
      {
        "state": "PO",
        "name": "Prato"
      },
      {
        "state": "RG",
        "name": "Ragusa"
      },
      {
        "state": "RA",
        "name": "Ravenna"
      },
      {
        "state": "RC",
        "name": "Reggio Calabria"
      },
      {
        "state": "RE",
        "name": "Reggio Emilia"
      },
      {
        "state": "RI",
        "name": "Rieti"
      },
      {
        "state": "RN",
        "name": "Rimini"
      },
      {
        "state": "RM",
        "name": "Roma"
      },
      {
        "state": "RO",
        "name": "Rovigo"
      },
      {
        "state": "SA",
        "name": "Salerno"
      },
      {
        "state": "SS",
        "name": "Sassari"
      },
      {
        "state": "SV",
        "name": "Savona"
      },
      {
        "state": "SI",
        "name": "Siena"
      },
      {
        "state": "SR",
        "name": "Siracusa"
      },
      {
        "state": "SO",
        "name": "Sondrio"
      },
      {
        "state": "SU",
        "name": "Sud Sardegna"
      },
      {
        "state": "TA",
        "name": "Taranto"
      },
      {
        "state": "TE",
        "name": "Teramo"
      },
      {
        "state": "TR",
        "name": "Terni"
      },
      {
        "state": "TO",
        "name": "Torino"
      },
      {
        "state": "TP",
        "name": "Trapani"
      },
      {
        "state": "TN",
        "name": "Trento"
      },
      {
        "state": "TV",
        "name": "Treviso"
      },
      {
        "state": "TS",
        "name": "Trieste"
      },
      {
        "state": "UD",
        "name": "Udine"
      },
      {
        "state": "VA",
        "name": "Varese"
      },
      {
        "state": "VE",
        "name": "Venezia"
      },
      {
        "state": "VB",
        "name": "Verbano-Cusio-Ossola"
      },
      {
        "state": "VC",
        "name": "Vercelli"
      },
      {
        "state": "VR",
        "name": "Verona"
      },
      {
        "state": "VV",
        "name": "Vibo Valentia"
      },
      {
        "state": "VI",
        "name": "Vicenza"
      },
      {
        "state": "VT",
        "name": "Viterbo"
      }
    ],
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "JE",
    "name": "Jersey",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "XK",
    "name": "Kosovo",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "LV",
    "name": "Latvia",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "LI",
    "name": "Liechtenstein",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "LT",
    "name": "Lithuania",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "LU",
    "name": "Luxembourg",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "MT",
    "name": "Malta",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "MD",
    "name": "Moldova, Republic of",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "MC",
    "name": "Monaco",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "ME",
    "name": "Montenegro",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "NL",
    "name": "Netherlands",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "MK",
    "name": "North Macedonia",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "NO",
    "name": "Norway",
    "eu": false,
    "language": "no",
    "currency": "NOK",
    "pricelist": "21",
    "market": "4"
  },
  {
    "country": "PL",
    "name": "Poland",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "PT",
    "name": "Portugal",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "RO",
    "name": "Romania",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "SM",
    "name": "San Marino",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "RS",
    "name": "Serbia",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "SK",
    "name": "Slovakia",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "SI",
    "name": "Slovenia",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "ES",
    "name": "Spain",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "SJ",
    "name": "Svalbard",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "SE",
    "name": "Sweden",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "CH",
    "name": "Switzerland",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "UA",
    "name": "Ukraine",
    "eu": false,
    "language": "en",
    "currency": "EUR",
    "pricelist": "22",
    "market": "2"
  },
  {
    "country": "US",
    "name": "United States",
    "eu": false,
    "language": "en",
    "states": [
      {
        "state": "AL",
        "name": "Alabama"
      },
      {
        "state": "AK",
        "name": "Alaska"
      },
      {
        "state": "AS",
        "name": "American Samoa"
      },
      {
        "state": "AZ",
        "name": "Arizona"
      },
      {
        "state": "AR",
        "name": "Arkansas"
      },
      {
        "state": "AA",
        "name": "Armed Forces Americas"
      },
      {
        "state": "AE",
        "name": "Armed Forces Europe"
      },
      {
        "state": "AP",
        "name": "Armed Forces Pacific"
      },
      {
        "state": "CA",
        "name": "California"
      },
      {
        "state": "CO",
        "name": "Colorado"
      },
      {
        "state": "CT",
        "name": "Connecticut"
      },
      {
        "state": "DE",
        "name": "Delaware"
      },
      {
        "state": "DC",
        "name": "District of Columbia"
      },
      {
        "state": "FM",
        "name": "Federated States of Micronesia"
      },
      {
        "state": "FL",
        "name": "Florida"
      },
      {
        "state": "GA",
        "name": "Georgia"
      },
      {
        "state": "GU",
        "name": "Guam"
      },
      {
        "state": "HI",
        "name": "Hawaii"
      },
      {
        "state": "ID",
        "name": "Idaho"
      },
      {
        "state": "IL",
        "name": "Illinois"
      },
      {
        "state": "IN",
        "name": "Indiana"
      },
      {
        "state": "IA",
        "name": "Iowa"
      },
      {
        "state": "KS",
        "name": "Kansas"
      },
      {
        "state": "KY",
        "name": "Kentucky"
      },
      {
        "state": "LA",
        "name": "Louisiana"
      },
      {
        "state": "ME",
        "name": "Maine"
      },
      {
        "state": "MH",
        "name": "Marshall Islands"
      },
      {
        "state": "MD",
        "name": "Maryland"
      },
      {
        "state": "MA",
        "name": "Massachusetts"
      },
      {
        "state": "MI",
        "name": "Michigan"
      },
      {
        "state": "MN",
        "name": "Minnesota"
      },
      {
        "state": "MS",
        "name": "Mississippi"
      },
      {
        "state": "MO",
        "name": "Missouri"
      },
      {
        "state": "MT",
        "name": "Montana"
      },
      {
        "state": "NE",
        "name": "Nebraska"
      },
      {
        "state": "NV",
        "name": "Nevada"
      },
      {
        "state": "NH",
        "name": "New Hampshire"
      },
      {
        "state": "NJ",
        "name": "New Jersey"
      },
      {
        "state": "NM",
        "name": "New Mexico"
      },
      {
        "state": "NY",
        "name": "New York"
      },
      {
        "state": "NC",
        "name": "North Carolina"
      },
      {
        "state": "ND",
        "name": "North Dakota"
      },
      {
        "state": "MP",
        "name": "Northern Mariana Islands"
      },
      {
        "state": "OH",
        "name": "Ohio"
      },
      {
        "state": "OK",
        "name": "Oklahoma"
      },
      {
        "state": "OR",
        "name": "Oregon"
      },
      {
        "state": "PW",
        "name": "Palau"
      },
      {
        "state": "PA",
        "name": "Pennsylvania"
      },
      {
        "state": "PR",
        "name": "Puerto Rico"
      },
      {
        "state": "RI",
        "name": "Rhode Island"
      },
      {
        "state": "SC",
        "name": "South Carolina"
      },
      {
        "state": "SD",
        "name": "South Dakota"
      },
      {
        "state": "TN",
        "name": "Tennessee"
      },
      {
        "state": "TX",
        "name": "Texas"
      },
      {
        "state": "UT",
        "name": "Utah"
      },
      {
        "state": "VT",
        "name": "Vermont"
      },
      {
        "state": "VI",
        "name": "Virgin Islands"
      },
      {
        "state": "VA",
        "name": "Virginia"
      },
      {
        "state": "WA",
        "name": "Washington"
      },
      {
        "state": "WV",
        "name": "West Virginia"
      },
      {
        "state": "WI",
        "name": "Wisconsin"
      },
      {
        "state": "WY",
        "name": "Wyoming"
      }
    ],
    "currency": "USD",
    "pricelist": "20",
    "market": "3"
  }
];